<template>
  <div class="test-buy-editpage">
    <div class="page-header">
      <h2>{{ $t('SidebarMenu.Menu87') }}</h2>
    </div>

    <TestbuyBaseInfo :productinfo="productinfo" :showaddress="false" />

    <div class="test-buy-edit-block">
      <el-divider content-position="center">订单状态</el-divider>
      <el-timeline>
        <el-timeline-item color="#0bbd87" v-if="currentstatus >= 0">
          <div class="test-buy-edit-timeline-content">
            <h2>
              <span>待下单</span>
              <el-button type="primary" icon="el-icon-edit-outline" size="mini" @click="editstep1 = true; disabled1 = false"></el-button>
              <i class="el-icon-info">请提供测买订单信息</i>
            </h2>
            <div class="test-buy-edit-timeline-content-body" v-if="editstep1 || currentstatus >= 1">
              <el-form label-width="80px" label-position="right" size="mini" :disabled="disabled1">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="下单时间">
                      <el-date-picker
                        v-if="disabled1 == false"
                        v-model="form.purchasedate"
                        type="date"
                        @change="changePurchasedate"
                        placeholder="选择日期">
                      </el-date-picker>
                      <span v-else>{{ form.purchasedate1 }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="订单号">
                      <el-input v-model="form.orderid" placeholder="电商平台订单编号"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="付款方式">
                      <el-input v-model="form.payment" placeholder="例如：支付宝、微信、代付等"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="库存">
                      <el-input v-model="form.stock" placeholder="不清楚请填写0"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="下单价格">
                  <el-col :span="5">
                    <el-input v-model="form.price" placeholder="商品价格，商品显示的最终金额" @change="totalCost(form.price, form.postage, form.tax)"></el-input>
                  </el-col>
                  <el-col :span="1" style="text-align: center;">+</el-col>
                  <el-col :span="5">
                    <el-input v-model="form.postage" placeholder="运费，如无请填写0" @change="totalCost(form.price, form.postage, form.tax)"></el-input>
                  </el-col>
                  <el-col :span="1" style="text-align: center;">+</el-col>
                  <el-col :span="5">
                    <el-input v-model="form.tax" placeholder="税费，如无请填写0" @change="totalCost(form.price, form.postage, form.tax)"></el-input>
                  </el-col>
                  <el-col :span="1" style="text-align: center;">=</el-col>
                  <el-col :span="6">
                    <el-input v-model="form.cost" placeholder="商品价格，填写后自动计算" disabled></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="订单截图">
                  <el-col :span="6">
                    <el-upload
                      :show-file-list="false"
                      class="upload-demo"
                      :action="uploadurl"
                      :data="{testId: this.testid, type: 15}"
                      :limit="1"
                      :on-success="imgUploaded">
                      <el-button size="mini" type="primary">点击上传</el-button>
                    </el-upload>
                    <el-image v-if="filelist[14] != null" :src="filelist[14]">
                      <div slot="placeholder" class="image-slot">
                        <i class="el-icon-loading"></i>
                      </div>
                    </el-image>
                  </el-col>
                </el-form-item>
                <el-form-item label="取消">
                  <el-checkbox v-model="form.failed10">商品已下架</el-checkbox>
                </el-form-item>
                <el-form-item label="备注" v-if="form.failed10">
                  <el-col :span="8">
                    <el-input
                      type="textarea"
                      :rows="2"
                      placeholder="请输入内容"
                      v-model="form.note">
                    </el-input>
                  </el-col>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="mini" @click="updateOrder()">确定</el-button>
                  <el-button size="mini" @click="editstep1 = false; disabled1 = true">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-timeline-item>

        <el-timeline-item color="#0bbd87" v-if="currentstatus >= 1">
          <div class="test-buy-edit-timeline-content">
            <h2>
              <span>待发货</span>
              <el-button type="primary" icon="el-icon-edit-outline" size="mini" @click="editstep2 = true; disabled2 = false"></el-button>
              <i class="el-icon-info">请更新发货物流信息</i>
            </h2>
            <div class="test-buy-edit-timeline-content-body" v-if="editstep2 || currentstatus >= 2">
              <el-form label-width="80px" label-position="right" size="mini" :disabled="disabled2">
                <el-row :gutter="20" v-if="currentstatus != 8">
                  <el-col :span="8">
                    <el-form-item label="快递名称">
                      <el-select v-model="form.express" :disabled="form.failed8">
                        <el-option
                          v-for="item in expresslist"
                          :key="item.value"
                          :label="item.value"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="快递单号">
                      <el-input v-model="form.expressid" placeholder="商品快递单号" :disabled="form.failed8"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="发货地">
                      <el-cascader
                        v-if="disabled2 == false"
                        :disabled="form.failed8"
                        ref="cascader"
                        v-model="form.shipment"
                        :options="cities"
                        @change="handleChange">
                      </el-cascader>
                      <span v-else>{{ form.shipment }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item label="取消">
                      <el-checkbox v-model="form.failed8">卖家未发货</el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="备注" v-if="form.failed8">
                  <el-col :span="8">
                    <el-input
                      type="textarea"
                      :rows="2"
                      placeholder="请输入内容"
                      v-model="form.note">
                    </el-input>
                  </el-col>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="mini" @click="updateExpress()">确定</el-button>
                  <el-button size="mini" @click="editstep2 = false; disabled2 = true">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-timeline-item>

        <el-timeline-item color="#0bbd87" v-if="currentstatus >= 2 && currentstatus != 8 && currentstatus != 12">
          <div class="test-buy-edit-timeline-content">
            <h2>
              <span>物流中</span>
              <el-button type="primary" icon="el-icon-edit-outline" size="mini" @click="editstep3 = true; disabled3 = false"></el-button>
              <i class="el-icon-info">收到测买商品后请在这里确认。&lt;日期可选，但默认为今天现在&gt;</i>
            </h2>
            <div class="test-buy-edit-timeline-content-body" v-if="editstep3 || currentstatus >= 3">
              <el-form label-width="80px" label-position="right" size="mini" :disabled="disabled3">
                <el-form-item label="收货日期" v-if="currentstatus != 9">
                  <el-col :span="8">
                    <el-date-picker
                      v-if="disabled3 == false"
                      v-model="form.receiptdate"
                      type="date"
                      placeholder="选择日期">
                    </el-date-picker>
                    <span v-else>{{ form.receiptdate1 }}</span>
                  </el-col>
                </el-form-item>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item label="取消">
                      <el-checkbox v-model="form.failed9">卖家截回快递</el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="备注" v-if="form.failed9">
                  <el-col :span="8">
                    <el-input
                      type="textarea"
                      :rows="2"
                      placeholder="请输入内容"
                      v-model="form.note">
                    </el-input>
                  </el-col>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="mini" @click="updateReceipt()">确定</el-button>
                  <el-button size="mini" @click="editstep3 = false; disabled3 = true">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-timeline-item>

        <el-timeline-item color="#0bbd87" v-if="currentstatus >= 3 && currentstatus != 8 && currentstatus != 9 && currentstatus != 12 && currentstatus != 13">
          <div class="test-buy-edit-timeline-content">
            <h2>
              <span>报告制作中</span>
              <el-button type="primary" icon="el-icon-edit-outline" size="mini" @click="editstep4 = true; disabled4 = false"></el-button>
              <i class="el-icon-info">请上传测买商品照片信息</i>
            </h2>
            <div class="test-buy-edit-timeline-content-body" v-if="editstep4 || currentstatus >= 4">
              <el-form label-width="80px" label-position="right" size="mini" :disabled="disabled4">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="快递包装">
                      <el-upload
                        :show-file-list="false"
                        class="upload-demo"
                        :action="uploadurl"
                        :data="{testId: this.testid, type: 1}"
                        :limit="1">
                        <el-button size="mini" type="primary">点击上传</el-button>
                      </el-upload>
                      <el-image v-if="filelist[0] != null" :src="filelist[0]">
                        <div slot="placeholder" class="image-slot">
                          <i class="el-icon-loading"></i>
                        </div>
                      </el-image>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="快递面单">
                      <el-upload
                        :on-success="returnimgpath"
                        :show-file-list="false"
                        class="upload-demo"
                        :action="uploadurl"
                        :data="{testId: this.testid, type: 2}"
                        :limit="1">
                        <el-button size="mini" type="primary">点击上传</el-button>
                      </el-upload>
                      <el-image v-if="filelist[1] != null" :src="filelist[1]">
                        <div slot="placeholder" class="image-slot">
                          <i class="el-icon-loading"></i>
                        </div>
                      </el-image>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="商品正面">
                      <el-upload
                        :show-file-list="false"
                        class="upload-demo"
                        :action="uploadurl"
                        :data="{testId: this.testid, type: 3}"
                        :limit="1">
                        <el-button size="mini" type="primary">点击上传</el-button>
                      </el-upload>
                      <el-image v-if="filelist[2] != null" :src="filelist[2]">
                        <div slot="placeholder" class="image-slot">
                          <i class="el-icon-loading"></i>
                        </div>
                      </el-image>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="商品背面">
                      <el-upload
                        :show-file-list="false"
                        class="upload-demo"
                        :action="uploadurl"
                        :data="{testId: this.testid, type: 4}"
                        :limit="1">
                        <el-button size="mini" type="primary">点击上传</el-button>
                      </el-upload>
                      <el-image v-if="filelist[3] != null" :src="filelist[3]">
                        <div slot="placeholder" class="image-slot">
                          <i class="el-icon-loading"></i>
                        </div>
                      </el-image>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="商品顶面">
                      <el-upload
                        :show-file-list="false"
                        class="upload-demo"
                        :action="uploadurl"
                        :data="{testId: this.testid, type: 5}"
                        :limit="1">
                        <el-button size="mini" type="primary">点击上传</el-button>
                      </el-upload>
                      <img class="reportuploadimg" v-if="filelist[4] != null" :src="filelist[4]" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="商品底面">
                      <el-upload
                        :show-file-list="false"
                        class="upload-demo"
                        :action="uploadurl"
                        :data="{testId: this.testid, type: 6}"
                        :limit="1">
                        <el-button size="mini" type="primary">点击上传</el-button>
                      </el-upload>
                      <img class="reportuploadimg" v-if="filelist[5] != null" :src="filelist[5]" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="商品左侧">
                      <el-upload
                        :show-file-list="false"
                        class="upload-demo"
                        :action="uploadurl"
                        :data="{testId: this.testid, type: 7}"
                        :limit="1">
                        <el-button size="mini" type="primary">点击上传</el-button>
                      </el-upload>
                      <img class="reportuploadimg" v-if="filelist[6] != null" :src="filelist[6]" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="商品右侧">
                      <el-upload
                        :show-file-list="false"
                        class="upload-demo"
                        :action="uploadurl"
                        :data="{testId: this.testid, type: 8}"
                        :limit="1">
                        <el-button size="mini" type="primary">点击上传</el-button>
                      </el-upload>
                      <img class="reportuploadimg" v-if="filelist[7] != null" :src="filelist[7]" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="标签">
                      <el-upload
                        :show-file-list="false"
                        class="upload-demo"
                        :action="uploadurl"
                        :data="{testId: this.testid, type: 10}"
                        :limit="1">
                        <el-button size="mini" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">挂牌、包装贴标、酒瓶贴标等</div>
                      </el-upload>
                      <img class="reportuploadimg" v-if="filelist[10] != null" :src="filelist[10]" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="序列号">
                      <el-upload
                        :show-file-list="false"
                        class="upload-demo"
                        :action="uploadurl"
                        :data="{testId: this.testid, type: 11}"
                        :limit="1">
                        <el-button size="mini" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">商品序列号(SN号)标签</div>
                      </el-upload>
                      <img class="reportuploadimg" v-if="filelist[11] != null" :src="filelist[11]" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item>
                  <el-button type="primary" size="mini" @click="updateReport()">确定</el-button>
                  <el-button size="mini" @click="editstep4 = false; disabled4 = true">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-timeline-item>

        <el-timeline-item color="#0bbd87" v-if="currentstatus >= 4 && currentstatus != 8 && currentstatus != 9 && currentstatus != 12 && currentstatus != 13">
          <div class="test-buy-edit-timeline-content">
            <h2>
              <span>报告已交付</span>
              <el-button type="primary" icon="el-icon-edit-outline" size="mini" @click="editstep11 = true; disabled11 = false"></el-button>
            </h2>
            <div class="test-buy-edit-timeline-content-body" v-if="editstep11 || currentstatus >= 4">
              <el-form label-width="80px" label-position="right" size="mini" :disabled="disabled11">
                <el-form-item label="交付日期">
                  <el-col :span="8">
                    <el-date-picker
                      v-if="disabled11 == false"
                      v-model="form.reportTime"
                      type="date"
                      placeholder="选择日期">
                    </el-date-picker>
                    <span v-else>{{ form.reportTime == '' || form.reportTime == null ? '未交付' : $moment(form.reportTime).format('YYYY-MM-DD')  }}</span>
                  </el-col>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="mini" @click="confirmReport()">确定</el-button>
                  <el-button size="mini" @click="editstep11 = false; disabled11 = true">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-timeline-item>

        <el-timeline-item color="#0bbd87" v-if="currentstatus >= 4 && currentstatus != 8 && currentstatus != 9 && currentstatus != 12 && currentstatus != 13">
          <div class="test-buy-edit-timeline-content">
            <h2>
              <span>退货中／返还中</span>
              <el-button type="primary" icon="el-icon-edit-outline" size="mini" 
                @click="editstep5 = true; returnback == 0 ? disabled5 = false : disabled6 = false">
              </el-button>
            </h2>
            <div class="test-buy-edit-timeline-content-body">
              <el-radio-group v-model="returnback" size="mini">
                <el-radio-button label="0">退货</el-radio-button>
                <el-radio-button label="1">返还</el-radio-button>
              </el-radio-group>

              <div class="test-buy-edit-timeline-content-body-show">
                <el-form label-width="100px" label-position="right" v-if="returnback == 0" size="mini" :disabled="disabled5">
                  <el-form-item label="退货单截图">
                    <el-col :span="12">
                      <el-upload
                        :show-file-list="false"
                        class="upload-demo"
                        :action="uploadurl"
                        :data="{testId: this.testid, type: 13}"
                        :limit="1">
                        <el-button size="mini" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">上传退货快递单</div>
                      </el-upload>
                      <img class="reportuploadimg" v-if="filelist[13] != null" :src="filelist[13]" />
                    </el-col>
                  </el-form-item>
                  <el-form-item label="快递费">
                    <el-col :span="8">
                      <el-input v-model="form.postage1" placeholder="运费，如无请填写0"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" size="mini" @click="updateReturn(0)">确认退货</el-button>
                    <el-button size="mini" @click="editstep5 = false; disabled5 = true">取消</el-button>
                  </el-form-item>
                </el-form>

                <el-form label-width="80px" label-position="right" v-if="returnback == 1" size="mini" :disabled="disabled6">
                  <el-form-item label="快递地址">
                    <el-col :span="8">
                      <el-input v-model="form.address2" placeholder="商品返还收件人地址"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="快递费">
                    <el-col :span="8">
                      <el-input v-model="form.postage2" placeholder="运费，如无请填写0"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="快递单">
                    <input type="file" />
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" size="mini" @click="updateReturn(1)">确认返还</el-button>
                    <el-button size="mini" @click="editstep6 = false; disabled6 = true">取消</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </el-timeline-item>

        <el-timeline-item color="#0bbd87" v-if="currentstatus >= 4">
          <!-- && currentstatus != 8 && currentstatus != 9 -->
          <div class="test-buy-edit-timeline-content">
            <h2>
              <span>完成</span>
              <el-button type="primary" icon="el-icon-edit-outline" size="mini" @click="editstep7 = true; disabled7 = false"></el-button>
            </h2>
            <div class="test-buy-edit-timeline-content-body">
              <el-form label-width="80px" label-position="right" size="mini" :disabled="disabled7">
                <el-form-item label="完成日期">
                  <el-col :span="8">
                    <el-date-picker
                      v-if="editstep7"
                      v-model="form.completedata"
                      type="date"
                      placeholder="选择日期">
                    </el-date-picker>
                    <span v-else>{{ form.completedata1 == '' || form.completedata1 == null ? '未完成' : $moment(form.completedata1).format('YYYY-MM-DD')  }}</span>
                  </el-col>
                </el-form-item>
                <el-form-item label="备注">
                  <el-col :span="8">
                    <el-input
                      type="textarea"
                      :rows="2"
                      placeholder="请输入内容"
                      v-model="form.note">
                    </el-input>
                  </el-col>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="mini" @click="updateComplete()">确认完成</el-button>
                  <el-button size="mini" @click="editstep7 = false; disabled7 = true">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-timeline-item>

      </el-timeline>
    </div>

    <el-dialog>

    </el-dialog>

  </div>
</template>

<script>
import TestbuyBaseInfo from './Components/TestbuyBaseInfo.vue'
export default {
  components: {
    TestbuyBaseInfo
  },
  data(){
    return{
      testid: this.$route.params.Testid,
      taskid: this.getCurrentInfo().taskid,
      form: {
        purchaseprice: '',
        purchasedate: '',
        purchasedate1: '',
        orderid: '',
        express: '',
        expressid: '',
        stock: '',
        shipment: '',
        shipmentformat: '',
        postalcharge: '',
        payment: '',
        pic: '',
        price: '',
        postage: '',
        tax: '',
        cost: '',
        receiptdate: '',
        receiptdate1: '',
        postage1: '',
        postage2: '',
        address2: '',
        completedata: '',
        completedata1: '',
        note: '',
        failed8: false,
        failed9: false,
        failed10: false,
        reportTime: ''
      },
      expresslist: require('./JSON/express.json').data,
      // locations: require('./JSON/location.json').data,
      cities: require('./JSON/cities.json').data,
      returnback: '0',
      productinfo: {},
      currentstep: '',
      currentstatus: 0,
      uploadurl: this.API_URL + '/v3/price/testbuy/upload',
      filelist: [],
      expressco: '',
      editstep1: false,
      editstep2: false,
      editstep3: false,
      editstep4: false,
      editstep5: false,
      editstep6: false,
      editstep7: false,
      editstep11: false,
      disabled1: true,
      disabled2: true,
      disabled3: true,
      disabled4: true,
      disabled5: true,
      disabled6: true,
      disabled7: true,
      disabled11: true,
    }
  },

  mounted(){
    this.testbuyDetail()
  },

  methods: {

    /**
     * 计算最终价格
     */
    totalCost: function(a, b, c){
      this.form.cost = a * 1 + b * 1 + c * 1
    },

    /**
     * 编辑按钮
     */
    editSteps: function(status){
      this.currentstep = status
    },

    /**
     * 取消按钮
     */
    cancelEdit: function(){
      this.currentstep = ''
    },

    /**
     * 获取图片地址
     */
    returnimgpath: function(response){
      this.filelist[0] = this.UPLOAD_URL + response.result
      this.expressco = this.UPLOAD_URL + response.result
      console.log(this.filelist[0])
    },

    /**
     * 获取测买流程详情
     */
    testbuyDetail: function(){
      let that = this
      let url = that.API_URL + '/v3/price/testbuy/testbuyDetail?taskId=' + that.taskid + '&testId=' + that.testid
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          let res = rex.results[0]
          that.productinfo = res
          that.form.purchasedate = res.orderTime != null ? that.$moment(res.orderTime).format('YYYY-MM-DD') : ''
          that.form.purchasedate1 = res.orderTime != null ? that.$moment(res.orderTime).format('YYYY-MM-DD') : ''
          that.form.orderid = res.orderNumer
          that.form.payment = res.payment
          that.form.stock = res.stock
          that.form.price = res.commodityPrice
          that.form.postage = res.postage
          that.form.tax = res.tax
          that.form.cost = res.orderPrice
          that.form.express = res.expressName
          that.form.expressid = res.expressNumber
          that.form.shipment = res.receiptAddress
          that.form.receiptdate1 = res.receiptDate != null ? that.$moment(res.receiptDate).format('YYYY-MM-DD') : ''
          that.form.postage1 = res.salesReturnFee
          that.form.postage2 = res.returnFee
          that.form.address2 = res.returnUrl
          that.form.note = res.note
          that.form.completedata1 = res.finishTime != null ? that.$moment(res.finishTime).format('YYYY-MM-DD') : ''
          that.currentstatus = res.status
          that.form.failed8 = res.status == 8 || res.status == 12 ? true : false
          that.form.failed9 = res.status == 9 || res.status == 13 ? true : false
          that.form.failed10 = res.status == 14 ? true : false
          that.form.reportTime = res.reportTime != null ? that.$moment(res.reportTime).format('YYYY-MM-DD') : ''
          that.returnback = res.status == 6 || res.status == 10 ? 1 : 0
          that.filelist = [
            res.packagePhoto,
            res.waybillPhoto,
            res.frontPhoto,
            res.backPhoto,
            res.topPhoto,
            res.bottomPhoto,
            res.leftPhoto,
            res.rightPhoto,
            null,
            res.labelPhoto,
            res.SN,
            null,
            res.salesReturnPhoto,
            res.returnPhoto,
            res.orderPhoto
          ]
        },
        error: function(response) {
          console.log('testbuyDetail', response)
        }
      })
    },


    /**
     * 待下单
     */
    updateOrder: function(){
      let that = this
      let _url = ''
      let _query = {}
      if(false == that.form.failed10){
        _url = that.API_URL + '/v3/price/testbuy/editOrder'
        _query = {
          testId: that.testid,
          orderTime: that.$moment(that.form.purchasedate).format('YYYY-MM-DD'), //下单时间
          orderNumer: that.form.orderid, //单号
          payment: that.form.payment, //支付方式
          stock: that.form.stock, //库存
          commodityPrice: that.form.price, //商品价格
          postage: that.form.postage, // 运费
          tax: that.form.tax, //税费
          orderPrice: that.form.cost, // 下单价格=commodityPrice+postage+tax
          status: that.currentstatus >= 1 ? that.currentstatus : 1 //状态 -- 1待下单 2待发货 3物流中 4制作报告 5退货中 6返还中 7完成
        }
      } else{
        _url = that.API_URL + '/v3/price/testbuy/editfinishTime'
        _query = {
          testId: that.testid,
          note: that.form.note,
          status: 14
        }
      }
      $.ajax({
        url:  _url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
				data: _query,
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
					console.log('updateOrder', rex)
          that.testbuyDetail()
          that.disabled1 = true
        },
        error: function(response) {
          console.log('updateOrder', response)
        }
      })
    },

    /**
     * 待发货
     */
    updateExpress: function(){
      let that = this
      let _url = ''
      let _query = {}
      if(false == that.form.failed8){
        _url = that.API_URL + '/v3/price/testbuy/editSipping'
        _query = {
          testId: that.testid,
          expressName: that.form.express, //快递公司
          expressNumber: that.form.expressid, //快递单号
          receiptAddress: that.form.shipmentformat, //发货地
          status: that.currentstatus >= 2 ? that.currentstatus : 2
        }
      } else{
        _url = that.API_URL + '/v3/price/testbuy/editfinishTime'
        _query = {
          testId: that.testid,
          note: that.form.note,
          status: 8
        }
      }
      $.ajax({
        url:  _url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
				data: _query,
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
					console.log('updateExpress', rex)
          that.testbuyDetail()
          that.disabled2 = true
        },
        error: function(response) {
          console.log('updateExpress', response)
        }
      })
    },

    /**
     * 确认收货
     */
    updateReceipt: function(){
      let that = this
      let _url = ''
      let _query = {}
      if(false == that.form.failed9){
        _url = that.API_URL + '/v3/price/testbuy/editReceiptDate'
        _query = {
          testId: that.testid,
          receiptDate: that.$moment(that.form.receiptdate).format('YYYY-MM-DD'),
          status: that.currentstatus >= 3 ? that.currentstatus : 3
        }
      } else{
        _url = that.API_URL + '/v3/price/testbuy/editfinishTime'
        _query = {
          testId: that.testid,
          note: that.form.note,
          status: 9
        }
      }
      $.ajax({
        url:  _url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
				data: _query,
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
					console.log('updateReceipt', rex)
          that.testbuyDetail()
        },
        error: function(response) {
          console.log('updateReceipt', response)
        }
      })
    },

    /**
     * 制作报告
     */
    updateReport: function(){
      let that = this
      let url = that.API_URL + '/v3/price/testbuy/editReport'
      let _query = {
        testId: that.testid,
        status: that.currentstatus >= 4 ? that.currentstatus : 4
      }
      $.ajax({
        url:  url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
				data: _query,
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
					console.log('updateReport', rex)
          that.testbuyDetail()
          that.disabled4 = true
        },
        error: function(response) {
          console.log('updateReport', response)
        }
      })
    },

    /**
     * 报告已交付
     */
    confirmReport: function(){
      let that = this
      that.apiloading = true
      let _url = that.API_URL + '/v3/price/testbuy/editReportStatus'
      let _query = {
        testId: that.testid,
        reportTime: that.$moment(that.form.reportTime).format('YYYY-MM-DD'),
        status: 11
      }
      $.ajax({
        url:  _url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
				data: _query,
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
					console.log('confirmReport', rex)
          that.testbuyDetail()
          that.disabled11 = true
          that.apiloading = false
        },
        error: function(response) {
          console.log('confirmReport', response)
        }
      })
    },

    /**
     * 确认退货/返还
     */
    updateReturn: function(){
      let that = this
      let url = that.API_URL + '/v3/price/testbuy/editsalesReturn'
      let _query = {
        testId: that.testid,
        salesReturnFee: that.form.postage1,
        returnUrl: that.form.address2,
        returnFee: that.form.postage2,
        status: that.setStatus56()
      }
      $.ajax({
        url:  url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
				data: _query,
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
					console.log('updateReturn', rex)
          that.testbuyDetail()
          that.disabled5 = true
          that.disabled6 = true
        },
        error: function(response) {
          console.log('updateReturn', response)
        }
      })
    },

    /**
     * 完成
     */
    updateComplete: function(){
      let that = this
      let url = that.API_URL + '/v3/price/testbuy/editfinishTime'
      let _query = {
        testId: that.testid,
        finishTime: that.$moment(that.form.completedata).format('YYYY-MM-DD'),
        note: that.form.note,
        status : that.completeStatus()
      }
      $.ajax({
        url:  url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
				data: _query,
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
					console.log('updateComplete', rex)
          that.testbuyDetail()
          that.editstep7 = false
          that.disabled7 = true
        },
        error: function(response) {
          console.log('updateComplete', response)
        }
      })
    },

    handleChange: function(){
      this.form.shipmentformat = this.$refs["cascader"].getCheckedNodes()[0].pathLabels.join(' ')
    },

    changePurchasedate: function(val){
      console.log(val)
    },

    imgUploaded: function(response, file, fileList){
      console.log(response)
      this.filelist[14] = this.UPLOAD_URL + response.result
    },

    setStatus56: function(){
      let that = this
      let _s = 0
      console.log(that.returnback)
      if(that.returnback * 1 == 0){
        _s = 5
      } else if(that.returnback * 1 == 1){
        _s = 6
      } else{
        _s = that.currentstatus
      }
      return _s
    },

    /**
     * 完成 状态
     */
    completeStatus: function(){
      let that = this
      let _s = 0
      if(that.currentstatus == 5 || that.currentstatus == 7){
        _s = 7
      } else if(that.currentstatus == 6 || that.currentstatus == 10){
        _s = 10
      } else if(that.currentstatus == 11){
        _s = 11
      } else if(that.currentstatus == 8 || that.currentstatus == 12){
        _s = 12
      } else if(that.currentstatus == 9 || that.currentstatus == 13){
        _s = 13
      } else{
        _s = 7
      }
      return _s
    },

  }
}
</script>